
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Users, Lightbulb, TrendingUp, Heart, Shield, Award } from 'lucide-react';

const WhyJoinUs = () => {
  const advantages = [
    {
      icon: Users,
      title: "Esprit d'équipe",
      description: "Rejoignez une équipe soudée et bienveillante où chaque voix compte"
    },
    {
      icon: Lightbulb,
      title: "Innovation",
      description: "Participez à des projets innovants dans le domaine de l'environnement"
    },
    {
      icon: TrendingUp,
      title: "Évolution de carrière",
      description: "Développez vos compétences avec des formations et des opportunités d'évolution"
    },
    {
      icon: Heart,
      title: "Impact positif",
      description: "Contribuez concrètement à la protection de l'environnement"
    },
    {
      icon: Shield,
      title: "Stabilité",
      description: "Bénéficiez de la solidité d'une entreprise familiale établie depuis plus de 25 ans"
    },
    {
      icon: Award,
      title: "Reconnaissance",
      description: "Votre travail est valorisé et reconnu dans un environnement stimulant"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold mb-6 text-fabre-gray">
            Pourquoi nous rejoindre ?
          </h2>
          <p className="text-lg text-gray-600">
            Chez Groupe Fabre Environnement, nous offrons bien plus qu'un emploi : 
            une opportunité de faire la différence pour notre planète.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {advantages.map((advantage, index) => (
            <Card key={index} className="hover:shadow-lg transition-shadow duration-300">
              <CardContent className="p-6 text-center">
                <div className="bg-fabre-lightgreen/10 w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4">
                  <advantage.icon className="h-8 w-8 text-fabre-green" />
                </div>
                <h3 className="text-xl font-semibold mb-3 text-fabre-gray">
                  {advantage.title}
                </h3>
                <p className="text-gray-600">
                  {advantage.description}
                </p>
              </CardContent>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyJoinUs;
